module.exports = __webpack_public_path__ + "static/media/start-cali.ac9b51c8.svg";